import { FeatureList } from 'core/constants/common';
import Feature from './feature';

export default class ReportEdit extends Feature {
  constructor(disabledFeatures: string[]) {
    super(FeatureList.reportEdit, disabledFeatures);
  }

  isAccessible(): boolean {
    return super.isRouteAccessible();
  }
}
